import React from "react";
import { useTranslation } from "react-i18next";

export const LiebherrGeneratorEngine = () => {
    const {t} = useTranslation()
    return(
        <>
        <div className="contentBox">
            <div>
                <div className="noticeBox">
                    <img src="/assets/images/notice.png" alt="해당 콘텐츠는 개발중 입니다."/>
                    <p>
                        <strong>{t("liebherr_32")}</strong>
                        {t("liebherr_33")}
                    </p>
                </div>
            </div>
        </div>
        </>
    )
}